import React from 'react'
import Navbar from '../components/Navbar'
import Terms from '../components/Terms'
import Polite from '../components/Polite'

const Politecs = () => {
  return (
    <div>
      <Navbar />
      <Polite />
    </div>
  )
}

export default Politecs